/* istanbul ignore file */

/* tslint:disable */

/* eslint-disable */
export var ContractType;

(function (ContractType) {
  ContractType["ANNUAL"] = "annual";
  ContractType["MONTHLY"] = "monthly";
})(ContractType || (ContractType = {}));